import { LOCAL_STORAGE_KEYS } from './local-storage-keys.js'
import { SESSION_STORAGE_KEYS } from './session-storage-keys.js'

export const KEYS = Object.assign({}, LOCAL_STORAGE_KEYS, SESSION_STORAGE_KEYS)
